import React from "react";

import { Paper as MuiPaper, PaperProps, styled } from "@mui/material";
import { spacing } from "@mui/system";

const Paper: React.FC<PaperProps> = (props) => {
  return <MuiPaper {...props}>{props.children}</MuiPaper>;
};

export default styled(Paper)(spacing);
